const modals = (state = [], action) => {
    switch (action.type) {
      case 'SHOW_MODAL':
      return {
          type: "SHOW_MODAL",
          modal: action.modal
        }
      default:
        return state
    }
  }
  
  export default modals